module.exports = __webpack_public_path__ + "static/media/Icon_PrintSystem.862f2d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_PrintSystem.svg
// module id = 2307
// module chunks = 0